import { render, staticRenderFns } from "./SnackbarComponent.vue?vue&type=template&id=9e200c34&scoped=true&lang=pug"
import script from "./SnackbarComponent.vue?vue&type=script&lang=js"
export * from "./SnackbarComponent.vue?vue&type=script&lang=js"
import style0 from "./SnackbarComponent.vue?vue&type=style&index=0&id=9e200c34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e200c34",
  null
  
)

export default component.exports